import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Modal from '../../../../../shared/Modal/Modal';
import { ModalContent } from '../ModalContent';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 30px 0;
  color: ${(props) => props.color};
`;

const Link = styled.a`
  font-size: 16px;
  line-height: 21px;
  text-decoration: underline;
  cursor: pointer;
`;

const Icon = styled.i`
  font-size: 20px;
  margin-left: 5px;
`;

export const Anchor = (props) => {
  const { t } = useTranslation();
  return (
    <Link {...props}>
      {t('site.purchase.select-package.carbon.how-it-works')}
    </Link>
  );
};

export const ModalLink = ({ color }) => {
  const ModalPopUp = Modal(Anchor, ModalContent, {}, '', {
    colorStyle: color,
  });

  return (
    <Wrapper color={color}>
      <ModalPopUp />
      <Icon className="material-icons">help_outline</Icon>
    </Wrapper>
  );
};

ModalLink.propTypes = {
  color: PropTypes.string,
};
